// Trello SALES TRACKER (626): a link's ?g= preselects the quiz gender and
// skips the gender step. Only "male" / "female" count; anything else (both,
// xyz, an array from ?g=a&g=b) is ignored so the gender step shows as normal.
// It is only a starting value: the visitor can still change it, and it never
// touches price, plan or account.
const QUERY_GENDERS = { male: "Male", female: "Female" };

// "female" -> "Female", "male" -> "Male", anything else -> "".
const normalizeQueryGender = (value) => {
    if (typeof value !== "string") return "";
    const key = value.trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(QUERY_GENDERS, key) ? QUERY_GENDERS[key] : "";
};

// Value for the `gender` cookie: "male" / "female", or "" when invalid.
const queryGenderCookieValue = (value) => normalizeQueryGender(value).toLowerCase();

module.exports = {
    normalizeQueryGender,
    queryGenderCookieValue,
};
